
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

/**
 * Exports data to CSV format and triggers download
 * @param data Array of data to export 
 * @param filename The name of the file (without extension)
 */
export const exportToCSV = <T extends Record<string, any>>(data: T[], filename: string) => {
  try {
    // Create CSV content
    const headers = Object.keys(data[0]);
    const csvContent = [
      headers.join(","),
      ...data.map((item) =>
        headers.map((key) => {
          const value = item[key];
          // Handle values that might contain commas or quotes
          if (value === null || value === undefined) return '""';
          const strValue = String(value);
          if (strValue.includes(",") || strValue.includes('"') || strValue.includes('\n')) {
            return `"${strValue.replace(/"/g, '""')}"`;
          }
          return strValue;
        }).join(",")
      ),
    ].join("\n");
    
    // Create and download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `${filename}.csv`);
  } catch (error) {
    console.error("Error exporting to CSV:", error);
  }
};

/**
 * Exports data to Excel format and triggers download
 * @param data Array of data to export
 * @param filename The name of the file (without extension)
 */
export const exportToExcel = <T extends Record<string, any>>(data: T[], filename: string) => {
  try {
    // Create workbook and worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    
    // Generate Excel file and download
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
};

/**
 * Format members data for export by transforming values to be more readable
 */
export const formatMembersForExport = (members: any[]) => {
  return members.map(member => ({
    Prénom: member.first_name,
    Nom: member.last_name,
    Email: member.email,
    "Montant": member.amount,
    "Don additionnel": member.additional_donation || 0,
    "Type d'adhésion": member.membership_type,
    "Statut du paiement": member.payment_status === "paid" ? "Payé" : "Non payé",
    "Date d'adhésion": new Date(member.created_at).toLocaleDateString('fr-FR')
  }));
};
